import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TestServer from './components/TestServer'
import styles from '../../../../styles.scss'

class TestServersSetting extends Component {
    update = (serverId) => {
        const testServers = [...this.props.testServers]

        // Check whether the server is in the list
        const index = testServers.indexOf(serverId)

        // If the server is unlisted we add it to the array
        // otherwise we remove it from the array
        if (index === -1) testServers.push(serverId)
        else testServers.splice(index, 1)

        // Update store
        this.props.update(testServers)
    }

    // Populate the list of test servers that can be enabled in launcher settings
    renderTestServers = () =>
        _.map(this.props.servers, (server, serverId) => (
            <TestServer
                key={serverId}
                name={server.name}
                serverId={serverId}
                checked={server.checked}
                update={() => this.update(serverId)}
            />
        ))

    render() {
        if (this.props.serverCount < 1) return null

        return (
            <div>
                <h1>{this.props.label}</h1>
                <ul className={styles.settingList}>{this.renderTestServers()}</ul>
            </div>
        )
    }
}

TestServersSetting.propTypes = {
    label: PropTypes.string,
    servers: PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.shape({
            name: PropTypes.string,
            checked: PropTypes.bool,
        }),
    }),
    serverCount: PropTypes.number,
    testServers: PropTypes.arrayOf(PropTypes.string),
    update: PropTypes.func,
}

export default TestServersSetting



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/TestServers/component.js